<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="card-group mb-0">
            <div class="card p-4">
              <div class="card-body">
                <h1 style="margin-bottom: 20px;">yytools后台修改密码</h1>
                <p class="text-muted"></p>
                <div class="input-group mb-3">
                  <span class="input-group-addon"><i class="icon-username"></i>
                  </span>
                  <input v-model.trim="userName" id="username" class="form-control" :class="nameError && 'is-invalid'" placeholder="手机号">
                </div>
                <div class="input-group mb-3">
                  <span class="input-group-addon"><i class="icon-password"></i>
                  </span>
                  <input v-model.trim="password" id="" maxlength="6" type="password" class="form-control" :class="passwordError && 'is-invalid'" placeholder="新密码">
                </div>
                <div class="input-group mb-3">
                  <span class="input-group-addon"><i class="icon-password"></i>
                  </span>
                  <input v-model.trim="verifyPassword"  maxlength="6"  type="password" class="form-control" :class="verifyPasswordError && 'is-invalid'" placeholder="校验新密码">
                </div>
                <div class="input-group mb-4">
                  <el-button size="small" type="primary" id="login" @click="reset">修改密码</el-button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  #login{
    width: 100%;
  }
  .btn-send-code{
    margin-left: 10px !important;
    width: 110px !important;
    padding: 0 !important;
  }
  .input-group-addon{
    padding: 10px 15px;
    background: #FFFFFF;
  }
</style>

<script>
  import countdown from '@xkeshi/vue-countdown'
  export default {
    name: 'Login',
    data() {
      return {
        userName: null,
        password: null,
        verifyPassword: null,
        verifyCode: null,
        nameError: false,
        passwordError: false,
        verifyPasswordError: false,
        sending: false,
      }
    },
    computed: {
    },
    components: {
      countdown
    },
    mounted(){

    },

    watch: {
      userName: function () {
        this.nameError = false;
      },
      password: function () {
        this.passwordError = false;
      },
    },

    methods: {
      onCountdownEnd() {
        this.sending = false;
      },

      // 重置密码
      reset() {
        if (this.isAjax) return;
        this.isAjax = true;

        let validated = this._validate();
        let that = this;
        if (validated.success) {
          lib.tmsapi.post({
            api: 'api/test/user/update',
            data: {
              phone_number: that.userName,
              password: that.password,
            },
            success: (res) => {
              this.$message.success("修改密码成功！");
              lib.cookie.rm('yytools_token');
              this.$router.push({ path: '/pages/login' });
            },
            error: (data) => {
              that.$message.error(data.error.msg)
              console.log(data);
            },
            complete: () => {
            }
          })
        } else {
          this.$message.error(validated.msg);
          this.isAjax = false;
        }
      },

      // 判断逻辑
      _validate() {
        // 校验
        if (!this.userName) {
          this.nameError = true;
          return {
            success: false,
            msg: '手机号不能为空'
          }
        }
        if (!/^[0-9]{11}$/.test(this.userName)) {
          return {
            success: false,
            msg: '手机号格式不正确'
          }
        }

        if(!this.password){
          return {
            success: false,
            msg: '新密码不能为空'
          }
        }
        if (!this.verifyPassword) {
          return {
            success: false,
            msg: '校验新密码不能为空'
          }
        }
        if (!/^[0-9]{6}$/.test(this.verifyPassword) || !/^[0-9]{6}$/.test(this.password)) {
          return {
            success: false,
            msg: '请输入6位数的密码'
          }
        }
        if (this.verifyPassword !== this.password) {
          return {
            success: false,
            msg: '新密码与校验新密码不一致'
          }
        }
        return {
          success: true
        };
      }
    }
  }
</script>

